import cacheLs from "../cacheLs"

export default {
  activePageCommit (state, data) {
    state.activePage = data
  },
  setLangCommit (state, data) {
    cacheLs.set_selected_lang(data)
    state.lang = data
  },
  layoutModeCommit (state, data) {
    state.layoutMode = data
  }
}
